import cleanString from '../cleanString'

const getSuggestionKey = ks => `${ks.itemKey}-${cleanString(ks.colourName).split(' ').join('-')}`

export default getSuggestionKey



// WEBPACK FOOTER //
// ./src/utilities/Data/Kit/getSuggestionKey.js